export let poweredBy = {
	brand: 'Engati',
	poweredBy: 'Powered by',
	url: '',
};

export const setter = (props) => {
	poweredBy = {
		...poweredBy,
		...props,
	};
};
